import Snippets from './Snippets'

export default Snippets
